<template>
  <!-- 法律法规 -->
  <div class="eprights-cont">
    <div class="left-tabs">
      <a @click="gotoFlfg">法律法规</a>
      <a class="active">职工维权知识问答</a>
    </div>
    <div class="right-laws">
      <h3 class="titleh3">职工维权知识问答</h3>
      <ul class="ruleList">
        <li
          v-for="(item, index) in list"
          :key="'zswd_' + item.pkid"
          @click="gotoDetail(item)"
        >
          <span>{{ item.doc_title }}</span>
          <span
            ><i class="time iconfont">&#xe74f;</i>发布时间：{{
              item.compose_time
            }}</span
          >
        </li>
      </ul>
      <div class="page-box">
        <a-pagination
          show-quick-jumper
          :total="pagination.total"
          v-model="pagination.current"
          :page-size.sync="pagination.pageSize"
          @change="handleTableChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getDocumentList } from '@/api/document.js';
export default {
  name: 'LawsRegulations',
  data() {
    return {
      params: {
        chan_id: 2,
        page: 1,
        size: 10,
      },
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
      },
      list: [],
    };
  },
  mounted() {
    this.getDocumentList();
  },
  methods: {
    getDocumentList() {
      getDocumentList(this.params).then((res) => {
        this.list = res.items;
        this.pagination.total = res.totalcount;
        this.pagination.pageSize = res.pagesize;
      });
    },
    gotoDetail(item) {
      let routeUrl = this.$router.resolve({
        name: 'Regulations2',
        query: { doc_id: item.pkid },
      });
      window.open(routeUrl.href, '_blank');
    },
    handleTableChange(page, pageSize) {
      // console.log('Page: ', page);
      // console.log('pageSize: ', pageSize);
      this.pagination.current = page;
      this.pagination.pageSize = pageSize;
      this.params.page = page;
      this.params.size = pageSize;
      this.getDocumentList();
    },
    gotoFlfg() {
      this.$router.push({ name: 'EpRightsProtection' });
    },
  },
};
</script>
<style scoped>
.eprights-cont {
  display: flex;
}
.left-tabs {
  width: 260px;
  text-align: center;
  padding-top: 20px;
}
.left-tabs a {
  display: inline-block;
  width: 220px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-size: 18px;
  color: #666;
  background: #fafbfc;
  border: 1px solid #d9dfe8;
  box-sizing: border-box;
}
.left-tabs a + a {
  margin-top: 10px;
}
.left-tabs a.active {
  color: #0079df;
  background: #f3f9ff;
  border: 1px solid #78c1ff;
}
.right-laws {
  flex: 1;
  padding-top: 10px;
  padding-right: 20px;
}
.ruleList {
  margin-bottom: 20px;
  min-height: 300px;
}
.ruleList li {
  list-style: none;
  line-height: 1.5;
  display: flex;
  border-bottom: 1px solid #ededed;
  margin-left: 12px;
  padding: 10px 0;
  position: relative;
  padding-left: 4px;
  cursor: pointer;
}
.ruleList li::before {
  content: '';
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #666;
  position: absolute;
  top: 50%;
  margin-top: -2px;
  left: -10px;
}
.ruleList li:last-child {
  border: 0;
}
.ruleList li span:first-child {
  font-size: 15px;
  color: #333;
  flex: 1;
  margin-right: 15px;
}
.ruleList li span:last-child {
  font-size: 15px;
  color: #999;
  width: 210px;
}
.ruleList li .time {
  margin-right: 10px;
}
.page-box {
  text-align: right;
  padding: 20px 0 40px 0;
}
</style>
